import { useState } from 'react'

import { assertNever } from '@/utils/assertNever'

import { ForgotPasswordInputEmail } from './ForgotPasswordInputEmail'
import { ResetConfirmed } from './ResetConfirmed'
import { ResetPassword } from './ResetPassword'

export const ForgotPasswordPage = () => {
  const [step, setStep] = useState<
    'InputEmail' | 'ResetPassword' | 'Confirmation'
  >('InputEmail')

  const [email, setEmail] = useState('')

  switch (step) {
    case 'InputEmail':
      return (
        <ForgotPasswordInputEmail
          email={email}
          onChangeEmail={setEmail}
          onGoNext={() => {
            setStep('ResetPassword')
          }}
        />
      )
    case 'ResetPassword':
      return (
        <ResetPassword
          email={email}
          onGoNext={() => {
            setStep('Confirmation')
          }}
        />
      )
    case 'Confirmation':
      return <ResetConfirmed />
    default:
      return assertNever(step)
  }
}
